import { trackCareersPageViewOpeningsClick } from "@faire/web-api/events/careersPage/click/viewOpenings";
import jobOpenings from "@faire/web-api/routes/careers/openings";
import { ArrowRight } from "@faire/web/slate/icons/Arrow";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import type { JSX } from "react";
import styled, { css } from "styled-components";

import { CTAButton } from "@faire/retailer/views/careers/__internal__/common/common";

export const ViewOpeningsButton: React.FC<{
  buttonText?: JSX.Element;
  isSecondary?: boolean;
}> = (props) => (
  <StyledCTAButton
    onClick={() => {
      trackCareersPageViewOpeningsClick();
    }}
    linkTo={jobOpenings()}
    variant={props.isSecondary ? "secondary" : "primary"}
    $isSecondary={props.isSecondary}
  >
    <SignUpButtonContent>
      {props.buttonText ?? (
        <StrictLocalMsg
          defaultMessage="View Openings"
          description={{
            text: "Button text to navigate to a job openings page",
          }}
        />
      )}
      <StyledArrowRight />
    </SignUpButtonContent>
  </StyledCTAButton>
);

export const StyledArrowRight = styled(ArrowRight)`
  opacity: 0;
  transition: 0.5s ease;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  right: 2px;
`;

export const SignUpButtonContent = styled.span`
  transition: 0.5s ease;
  position: relative;
  padding: 0 10px;
`;

export const StyledCTAButton = styled(CTAButton)<{
  $isSecondary?: boolean;
}>`
  ${(props) =>
    props.$isSecondary
      ? css`
          border: none;
        `
      : ""}
  &:hover {
    ${SignUpButtonContent} {
      padding: 0 20px 0 0;
    }

    ${StyledArrowRight} {
      opacity: 1;
      right: 0;
    }
  }
`;
